<div class="rating">
  <svg-icon style="height: 20px" [svgStyle]="{'width.px': 20, 'height.px': 20}" src="/assets/icons/star_2.svg"></svg-icon>
  <div class="text strong dot_after">
    {{hostel?.overallRating | number: '1.0-2'}}
  </div>
  <div class="text light dot_after">
    {{hostel?.totalReviews ?? 0}}&nbsp;reviews
  </div>
  <div class="text light">
    {{hostel?.propertyRecommendationCount ?? 0}}&nbsp;recommendations
  </div>
</div>
<div class="comments">
  <app-comment-mobile *ngFor="let review of top4Reviews" [review]="review"></app-comment-mobile>
</div>
<div class="button-wrapper" *ngIf="(hostel?.amenities?.length ?? 0) > 5">
  <button class="btn btn-theme btn-large" (click)="bottomSheet.open()" [disabled]="!hostel?.totalReviews">
    <span>View all&nbsp;{{hostel?.totalReviews}}&nbsp;Reviews</span>
  </button>
</div>
<app-bottom-sheet #bottomSheet [template]="comment_list"></app-bottom-sheet>
<ng-template #comment_list>
  <div class="bottom-sheet-comment-wrapper">
    <app-comment-mobile *ngFor="let review of (hostel?.reviews ?? [])" [review]="review" [className]="'bottom-sheet-comment'"></app-comment-mobile>
  </div>
</ng-template>
